import {
  ACCOMMODATION_SERVICES_SECTOR,
  ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
  ARTS_ENTERTAINMENT_SECTOR,
  CONSTRUCTION_SECTOR,
  EDUCATIONAL_SERVICES_SECTOR,
  FINANCE_AND_INSURANCE_SECTOR,
  FISHING_AND_HUNTING_SECTOR,
  HEALTH_CARE_SECTOR,
  INFORMATION_SECTOR,
  MANAGEMENT_OF_COMPANIES_SECTOR,
  MANUFACTURING_SECTOR,
  MINING_QUARRYING_OIL_AND_GAS_SECTOR,
  OTHER_SERVICES_SECTOR,
  PUBLIC_ADMINISTRATION_SECTOR,
  REAL_ESTATE_SECTOR,
  RETAIL_TRADE_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  TRANSPORTATION_AND_WAREHOUSING_SECTOR,
  UTILITIES_SECTOR,
  WHOLESALE_TRADE_SECTOR,
} from '../industrySectorOptions';

export const SECTOR_OPTIONS_UA = [
  { value: FISHING_AND_HUNTING_SECTOR, label: 'Сільське, лісове господарство, рибальство та полювання' },
  { value: MINING_QUARRYING_OIL_AND_GAS_SECTOR, label: 'Добувна промисловість, розробка кар’єрів, нафта і газ' },
  { value: UTILITIES_SECTOR, label: 'Постачання електроенергії, газу, пари та водопостачання' },
  { value: CONSTRUCTION_SECTOR, label: 'Будівництво' },
  { value: MANUFACTURING_SECTOR, label: 'Переробна промисловість' },
  { value: WHOLESALE_TRADE_SECTOR, label: 'Оптова торгівля' },
  { value: RETAIL_TRADE_SECTOR, label: 'Роздрібна торгівля' },
  { value: TRANSPORTATION_AND_WAREHOUSING_SECTOR, label: 'Транспорт і складське господарство' },
  { value: INFORMATION_SECTOR, label: 'Інформація та телекомунікації' },
  { value: FINANCE_AND_INSURANCE_SECTOR, label: 'Фінанси та страхування' },
  { value: REAL_ESTATE_SECTOR, label: 'Операції з нерухомістю, оренда та лізинг' },
  { value: SCIENTIFIC_SERVICES_SECTOR, label: 'Професійні, наукові та технічні послуги' },
  { value: MANAGEMENT_OF_COMPANIES_SECTOR, label: 'Управління компаніями та підприємствами' },
  {
    value: ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
    label: 'Адміністративні та допоміжні послуги, управління відходами та рекультивація',
  },
  { value: EDUCATIONAL_SERVICES_SECTOR, label: 'Освітні послуги' },
  { value: HEALTH_CARE_SECTOR, label: 'Охорона здоров’я та соціальна допомога' },
  { value: ARTS_ENTERTAINMENT_SECTOR, label: 'Мистецтво, розваги та відпочинок' },
  { value: ACCOMMODATION_SERVICES_SECTOR, label: 'Тимчасове розміщення та послуги харчування' },
  { value: OTHER_SERVICES_SECTOR, label: 'Інші послуги (крім державного управління)' },
  { value: PUBLIC_ADMINISTRATION_SECTOR, label: 'Державне управління' },
];
